import {createLazyFileRoute} from '@tanstack/react-router'

import FlashDeals from '@/views/FlashDeals/FlashDeals'

export const Route = createLazyFileRoute('/_shop/flash-deals/')({
  component: FlashDeals,
})
